import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getEntityAudits } from '@dealstack/frontend/shared/dataExchange/services/audit.service.ts';

const RECENT_ACTIVITY_LIMIT = 3;

export const useInvestorRecentActivity = (personId?: string) => {
	const auditEndpoint = formatUnicorn(API_PATHS.AUDIT_PERSON_PERSONID_GET, {
		personId: personId ?? '',
	});

	const { data, isLoading, isError } = useQuery({
		queryKey: [auditEndpoint, { entityId: personId ?? '' }],
		queryFn: ({ signal }) => getEntityAudits(auditEndpoint, signal),
		enabled: !!personId,
	});

	const audits = useMemo(() => (data ?? []).slice(0, RECENT_ACTIVITY_LIMIT), [data]);

	return { audits, isLoading, isError };
};
